/** 从 Input 或 TextareaWithInsertParam 组件 ref 取原生 textarea */
export function getTextareaElFromInputRef(comp) {
  if (!comp) return null
  if (typeof comp.getTextareaEl === 'function') return comp.getTextareaEl()
  return (
    (comp.$refs && comp.$refs.textarea) ||
    (comp.$el && comp.$el.querySelector && comp.$el.querySelector('textarea'))
  )
}

/** 在光标处直接插入文本（记忆变量、停顿标签等） */
export function buildInlineInsertText(token) {
  return String(token)
}

export function buildInsertParamText(v0, start, token) {
  const t = String(token)
  if (!v0.length) return t
  if (start === 0) return `${t}\n`
  const before = v0[start - 1]
  const after = start < v0.length ? v0[start] : ''
  if (before === '\n') {
    if (after && after !== '\n') return `${t}\n`
    return t
  }
  return `\n${t}`
}

export function focusTextareaAt(ta, pos, nextLength) {
  if (!ta) return
  try {
    ta.focus()
    const safePos = Math.min(pos, nextLength)
    ta.setSelectionRange(safePos, safePos)
  } catch (e) {
    // ignore
  }
}
